/* eslint-disable */
import axios from 'axios';
import statusCode from 'utils/StatusCode';

const serverUrl = process.env.REACT_APP_BACKEND_URL;
const USING_SUBDOMAIN = process.env.REACT_APP_USING_SUBDOMAIN || false;

// store Report api call in Personal Identification
export const storeReport = async (form) => {
  if (Object.keys(form).length > 0) {
    const data = new FormData();
    data.append('identification', 2);
    data.append('name', form.personName);
    data.append('email', form.email);
    data.append('is_urgent', form.isUrgent);
    data.append('site', form.site);
    data.append('city', form.city);
    data.append('state', form.stateValue);
    data.append('country', form.country);
    data.append('phone', form.phone);
    const res = await axios.post(`${serverUrl}store-reporting-data`, data);
    return res.data;
  }
  const res = await axios.post(`${serverUrl}store-reporting-data`);
  return res.data;
};
// Victims api calls in Identify Subject
export const storeVictim = async (victim1, victim2, reportId) => {
  const data = new FormData();
  data.append('identification', 1);
  data.append('name', victim1.personName);
  data.append('email', victim1.email);
  data.append('employer', victim1.employer);
  data.append('work_location', victim1.workLocation);
  data.append('city', victim1.city);
  data.append('state', victim1.stateValue);
  data.append('zip', victim1.zip);
  data.append('phone', victim1.phoneNumber);
  data.append('address', victim1.address);
  data.append('report_id', reportId);
  if (Object.keys(victim1).length > 0) {
    data.append('victim1', 1);
  } else {
    data.append('victim2', 1);
  }
  const res = await axios.post(`${serverUrl}store-victim-data`);
  return statusCode(res.data.status).then((response) => {
    return response;
  });
};

// store Subject api call in Identify Subject
export const storeSubject = async (subject1, subject2, reportId) => {
  const data = new FormData();
  data.append('report_id', reportId);
  data.append('name', subject2.name);
  data.append('email', subject2.email);
  data.append('phone', subject2.phoneNumber);
  data.append('employer', subject2.employer);
  data.append('work_location', subject2.workLocation);
  data.append('address', subject2.address);
  data.append('city', subject2.city);
  data.append('state', subject2.state);
  data.append('zip', subject2.zip);
  data.append('relationship_to_the_company', subject2.relationToCompany);
  data.append('gender', subject2.gender);
  data.append('other_details', subject2.pleaseDescribe);
  data.append('age', subject2.approxAge);
  data.append('height', subject2.height);
  data.append('weight', subject2.weight);
  data.append('hair_color', subject2.hairColor);
  data.append('vehicle_year', subject2.vehicleYear);
  data.append('vehicle_make', subject2.vehicleMake);
  data.append('vehicle_model', subject2.vehicleModel);
  data.append('vehicle_color', subject2.vehicleColor);
  data.append('vehicle_detail', subject2.vehicleOtherDetails);
  data.append('license_tag', subject2.licenseTag);
  if (Object.keys(subject1).length > 0) {
    data.append('subject1', 1);
  } else {
    data.append('subject2', 1);
  }
  const res = await axios.post(`${serverUrl}store-reporting-subject`);
  return statusCode(res.data.status).then((response) => {
    return response;
  });
};

// Store Answers api call in Identify Subject
export const storeAnswers = () => {
  let answers = [];
  answers = localStorage.getItem('answers');
  const jsonFormat = JSON.parse(answers);
  axios.post(`${serverUrl}save-report-answers`, jsonFormat, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

// Sub Domain api call for Welcome Page
export const subDomain = async () => {
  let orgKey = '';
  console.log('USING_SUBDOMAIN', USING_SUBDOMAIN);
  if (USING_SUBDOMAIN === 'true') {
    let urlParts = window.location.hostname.split('.');
    orgKey = urlParts[0];

    if (orgKey === 'www' && urlParts.length > 2) {
      orgKey = urlParts[1];
    }
  } else {
    console.log('window.location.pathname', window.location.pathname);
    let urlParts = window.location.pathname.split('/');
    orgKey = urlParts[1]?.replace('/', '');
  }

  localStorage.setItem('orgKey', orgKey);

  return axios.get(`${serverUrl}organizations?sub_domain=${orgKey}`);

  // .then((res) => {
  //   if (res && res.data && res.data.length > 0) {
  //     res.data.forEach((org) => {
  //       console.log('org.sub_domain', org.sub_domain, orgKey);
  //       if (org.sub_domain === orgKey) {
  //         localStorage.setItem('orgId', org.id);
  //         return org.id;
  //       }
  //     });
  //   }
  // })
  // .catch((err) => {
  //   // Handle errors
  //   console.error(err);

  // });
};

// InsertReport ID to edit information
export const getReportID = async (id) => {
  const res = await axios.get(`${serverUrl}get-report-data?report_id=${id}`);
  return res.data;
};

// add New Information to add new Information
export const addExistingReport = async (report, files, text) => {
  const data = new FormData();
  const images = files;
  images.forEach((file, index) => {
    data.append(`attachments[${index}]attachment`, file);
  });
  data.append('report', report);
  data.append('description', text);
  data.append('title', 'title');
  data.append('type', 'ALL');
  data.append('variant', 'INFORMATION');
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
      applicationName: 'reporter'
    }
  };
  const res = await axios.post(
    `${serverUrl}additionalmaterials/`,
    data,
    config
  );

  return res;
};

// InsertReport ID to report status
export const reportStatus = async (id) => {
  if (!id) return;

  const res = await axios.get(`${serverUrl}reports/`, {
    params: {
      unique_code: id
    }
  });
  return res;
};

// notifictation
export const sendNotification = async (reportId, notification) => {
  const data = new FormData();
  data.append('report_id', reportId);
  data.append('notifications', notification);
  axios.post(`${serverUrl}receive_notifications`, data);
};

// Get Questions
export const fetchQuestions = async () => {
  const res = await axios.get(`${serverUrl}surveys/1/questions`);
  return res;
};

function objectToFormData(obj, formData, namespace) {
  formData = formData || new FormData();
  for (const property in obj) {
    if (obj.hasOwnProperty(property)) {
      const formKey = namespace ? `${namespace}[${property}]` : property;
      if (
        typeof obj[property] === 'object' &&
        !(obj[property] instanceof File)
      ) {
        objectToFormData(obj[property], formData, formKey);
      } else {
        formData.append(formKey, obj[property]);
      }
    }
  }
  return formData;
}

export const postAnswers = async (answers) => {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      applicationName: 'reporter'
    }
  };

  const data = objectToFormData(answers);
  const res = await axios.post(`${serverUrl}reports/`, answers, config);
  return res;
};

export const getStatusMessages = async (reportId) => {
  return await axios.get(`${serverUrl}statusupdates?report=${reportId}`);
};

export const getVictimsQuestions = () =>
  axios.get(`${serverUrl}surveys/1/questions/person`, {
    params: {
      type: 'question_victim',
      applicationName: 'reporter'
    }
  });

export const postNewVictim = (data) => {
  const formData = new FormData();
  const victim = data?.victim;
  const customFields = data?.custom_fields;

  formData.append('victim.person_type', victim.person_type);
  formData.append('victim.description', victim.description);
  formData.append('victim.report', victim.report);
  formData.append('victim.full_name', victim.full_name);
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
      applicationName: 'reporter'
    }
  };
  return axios.post(`${serverUrl}victims/`, formData, config);
};

export const postVictimAnswers = (reportId, answers, report_type) =>
  axios.post(`${serverUrl}reports/${reportId}/answers`, answers, {
    headers: {
      applicationName: 'reporter'
    },
    params: {
      report_type
    }
  });

export const getReportByUniqueCode = async (unique_code) => {
  if (!unique_code) return;

  const res = await axios.get(`${serverUrl}reports/`, {
    params: {
      unique_code
    }
  });
  return res;
};
